export enum AccountType {
    DEPOSITORY = 'depository',
    CREDIT = 'credit',
    LOAN = 'loan',
    BROKERAGE = 'brokerage',
    INVESTMENT = 'investment',
    UNKNOWN = 'unknown',
    OTHER = 'other'
}
